// Maximale Termindauer je Tag.
//
// Ein Tag kann vorgeben, wie lange ein Besuch höchstens dauern darf (z.B.
// „Handwerkende: 5 Tage"). Gezählt werden Kalendertage inklusive Start- und
// Endtag: ein Termin am selben Tag ist 1 Tag, Montag bis Freitag sind 5.
//
// Sind mehrere Tags gewählt, gilt der strengste Wert. Tags ohne Angabe
// begrenzen nicht.

const startOfDay = (value) => {
  const date = value instanceof Date ? new Date(value) : new Date(String(value));
  if (Number.isNaN(date.getTime())) return null;
  date.setHours(0, 0, 0, 0);
  return date;
};

/** Kalendertage von Start bis Ende, Start- und Endtag eingeschlossen. */
export function countCalendarDays(start, end) {
  const from = startOfDay(start);
  const to = startOfDay(end) || from;
  if (!from || !to) return null;
  const days = Math.round((to - from) / 86400000) + 1;
  return days > 0 ? days : 1;
}

/** Strengste Vorgabe der gewählten Tags, oder `null` wenn keine greift. */
export function maxDurationForTags(tagOptions, labels) {
  const selected = new Set(labels || []);
  const limits = (tagOptions || [])
    .filter((option) => selected.has(option.value))
    .map((option) => option.maxDurationDays)
    .filter((value) => Number.isFinite(value) && value > 0);
  return limits.length ? Math.min(...limits) : null;
}

/**
 * Überschreitet der Zeitraum die Vorgabe der gewählten Tags?
 *
 * Gibt `null` zurück, wenn alles passt, sonst `{ days, max }` — der Aufrufer
 * baut daraus seine Meldung.
 */
export function checkTagDuration(tagOptions, labels, start, end) {
  const max = maxDurationForTags(tagOptions, labels);
  if (!max) return null;
  const days = countCalendarDays(start, end);
  if (!days || days <= max) return null;
  return { days, max };
}
